import { ServiceCategoryList } from "../../Types/state/masterdata";

export interface IState {
  categories: ServiceCategoryList[];
  categoryCount: number;
}

type Action = any;

export const categoriesReducer = (
  state: IState = {
    categories: [],
    categoryCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_CATEGORY":
      return {
        ...state,
        categories:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.categories, ...action?.payload?.data],
        categoryCount: action?.payload?.count,
      };
    case "UPDATE_CATEGORY":
      return {
        ...state,
        categories: state?.categories?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_CATEGORY":
      return {
        ...state,
        categories: state?.categories?.filter((elem: any) => elem?._id !== action?.payload),
      };
    default:
      return state;
  }
};
